import React, { useEffect, useState, useMemo, useContext } from "react";
import {
  TextField,
  Button,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { AuthContext } from "../../utils/userProvider";

import DataTable from "react-data-table-component";
import moment from "moment";

import useReferralCodes from "../../queries/ReferralCodes/getReferralCodes";
import Loader from "../../components/Loader";
import {
  ListPageShell,
  ListPageCard,
  ListPageHeader,
  dataTableCustomStyles,
} from "../../components/ListPage";

const ReferralCodes = () => {
  const [referralCodesTable, setReferralCodesTable] = useState([]);
  const { authState, setAuthState } = useContext(AuthContext);
  const [filterText, setFilterText] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [availableYears, setAvailableYears] = useState([]);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  let columns = [
    {
      name: "Generated from Reservation Id",
      selector: "owner_transaction.reservationId",
      sortable: true,
    },
    {
      name: "Referral Code",
      selector: "code",
      sortable: true,
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
    },
    {
      name: "Type",
      selector: "type",
      sortable: true,
    },
    {
      name: "Created At",
      selector: "createdAt",
      sortable: true,
      cell: (row, index, column, id) => {
        return (
          <span>{moment(row.createdAt).format("DD MMM YYYY hh:mm:ss A")}</span>
        );
      },
    },
  ];

  const [response, reset] = useReferralCodes(selectedYear);

  const handleFilterText = (event) => {
    setFilterText(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  // Generate available years (current year + 3 previous years)
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 4 }, (_, i) => currentYear - i);
    setAvailableYears(years);
  }, []);

  const filteredItems = referralCodesTable.filter(
    (item) =>
      (item.code &&
        item.code
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase())) ||
      (item.owner_transaction &&
        item.owner_transaction.reservationId
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()))
  );

  useEffect(() => {
    if (response.data) {
      console.log(response.data);
      setReferralCodesTable([...response.data]);
    }
  }, [response]);

  const newRefCode = () => {
    window.location.href = "/dashboard/referralCodes/new";
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {authState.role == "Executive" && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={newRefCode}
              sx={{ mr: 1.25 }}
            >
              Manual Referral Code
            </Button>
          )}
          <FormControl
            variant="outlined"
            size="small"
            style={{ minWidth: 120 }}
          >
            <InputLabel>Year</InputLabel>
            <Select
              value={selectedYear}
              onChange={handleYearChange}
              label="Year"
            >
              {availableYears.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            id="filter-text"
            onChange={handleFilterText}
            label="Search"
            variant="outlined"
            size="small"
            value={filterText}
          />
        </div>
      </div>
    );
  }, [filterText, availableYears, selectedYear]);

  return (
    <ListPageShell>
      <ListPageCard>
        {response.loading && <Loader />}
        {!response.loading && (
          <div>
            <ListPageHeader title="Referral Codes" />
            <DataTable
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 20, 30]}
              noHeader={true}
              subHeader
              data={filteredItems}
              columns={columns}
              subHeaderComponent={subHeaderComponentMemo}
              customStyles={dataTableCustomStyles}
            />
          </div>
        )}
      </ListPageCard>
    </ListPageShell>
  );
};

export default ReferralCodes;
